export default {
  instagram: 'Instagram',
  instagramcomments: 'Comentarios en Instagram',
  facebook: 'Facebook',
  facebookinbox: 'Inbox de Facebook',
  facebookgroups: 'Grupos en Facebook',
  facebookcomments: 'Comentarios en Facebook',
  youtube: 'YouTube',
  youtubecomments: 'Comentarios en YouTube',
  twitter: 'Twitter',
  twitterinbox: 'Inbox de Twitter',
  tumblr: 'Tumblr',
  news: 'Portales',
  blogs: 'Blogs',
  foruns: 'Foros',
  comentariosemartigos: 'Comentarios en Artículos',
  googleplay: 'Google Play',
  googleplus: 'Google Plus',
  googlemybusiness: 'Google My Business',
  foursquare: 'Foursquare',
  buscape: 'Evaluaciones de Productos',
  reclameaqui: 'Reclame Aqui',
  linkedin: 'LinkedIn',
  linkedincomments: 'Comentarios en LinkedIn',
  tv: 'TV',
  radio: 'Radio',
  impressas: 'Impreso',
  portais: 'Portales',
  tiktok: 'TikTok',
  blip: 'Blip',
  importeddata: 'Datos Importados',
  bluesky: 'Bluesky',
  notclassified: 'No Clasificado',
};
